// pages/Company/CompanyEntryPage.jsx
// ─────────────────────────────────────────────────────────────
// NEW — the actual first screen of the payroll feature, replacing
// direct navigation into CompanyCreatePage as the landing point for
// anyone with zero companies. Previously CompanyDashboardPage.jsx's
// "no companies" state went straight to a single "Create Company"
// button — which silently assumes every first-time visitor is a
// founder/owner. Someone who was INVITED to a company (a finance
// person, a staff member someone else set up) has no reason to be
// shown a company-creation form at all; this fork prevents that
// wrong-context dead end.
//
// ROUTING — mounted at /business/landing. The dashboard itself
// (CompanyDashboardPage.jsx) lives at /business; this entry/fork
// screen is deliberately a DIFFERENT path so the two are never
// confused — CompanyDashboardPage's existing "no companies" inline
// branch should redirect here (navigate("/business/landing")) instead
// of rendering its own create-prompt, once wired in.
// ─────────────────────────────────────────────────────────────
import { useNavigate } from "react-router-dom";
import MobileBottomNav from "../../components/feature/MobileBottomNav";

export default function CompanyEntryPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg flex flex-col font-display">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 text-center">
        <div className="w-16 h-16 bg-brand-light rounded-3xl flex items-center justify-center mb-5">
          <i className="ri-team-line text-brand text-3xl" />
        </div>
        <h1 className="text-primary font-bold text-2xl mb-2">Pay your team, all in one place</h1>
        <p className="text-muted text-sm max-w-xs mb-10">
          Set up your company in minutes, or join one you've already been invited to.
        </p>

        <div className="w-full max-w-sm space-y-3">
          <button
            onClick={() => navigate("/business/new")}
            className="w-full bg-brand hover:bg-brand-hover text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            <i className="ri-building-line" />
            Set up my company
          </button>
          <button
            onClick={() => navigate("/business/join")}
            className="w-full bg-surface border-2 border-border-strong hover:border-brand-border text-secondary py-4 rounded-2xl font-bold text-sm transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            <i className="ri-mail-open-line" />
            I was invited to a company
          </button>
        </div>
      </div>

      <p className="text-center text-faint text-xs pb-8 px-6">
        Already part of a company on a different account?{" "}
        <span className="text-secondary">Make sure you're signed in with the email you were invited on.</span>
      </p>

      <MobileBottomNav />
    </div>
  );
}
